import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconApproveComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Approve${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M40.58 7.063a2.5 2.5 0 01.357 3.517l-15.5 19a2.5 2.5 0 01-3.705.188l-8-8a2.5 2.5 0 013.536-3.536l6.044 6.044L37.062 7.42a2.5 2.5 0 013.518-.357z" fill={useCurrentColor ? 'currentColor' : '#69718C'}/><path fillRule="evenodd" clipRule="evenodd" d="M6 11a4 4 0 014-4h22l-3.5 4H10v26h26V23l4-5.5V37a4 4 0 01-4 4H10a4 4 0 01-4-4V11z" fill={useCurrentColor ? 'currentColor' : '#69718C'}/></svg>;
}

const IconApprove = React.forwardRef(IconApproveComponent);
export default IconApprove;
